"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstallmentsQuantityButton = exports.MonthlyFeeObservations = exports.InstallmentInfo = exports.InstallmentsLabel = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _typography = require("@creditas-lab/typography");

var _styledTools = require("styled-tools");

const Container = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.Container = Container;
Container.Information = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
`;
Container.Installments = _stylitas.styled.div`
  width: 90vw;
  padding-bottom: 16px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -webkit-overflow-scrolling: scroll;
  text-align: center;

  &::-webkit-scrollbar {
    display: none;
  }

  ${_styleUtilities.media.md`
    width: 100%;
  `}

  & button {
    display: inline-block;
    width: 60px;
    margin: 0 8px;
  }
`;
const InstallmentsQuantityButton = _stylitas.styled.button`
  ${props => _styleUtilities.typography.sm(props.theme)};
  border: none;
  cursor: pointer;
  width: 60px;
  padding: 12px 20px;
  border-radius: 10px;
  border: 1px solid
    ${(0, _styledTools.ifProp)('isSelected', (0, _styledTools.theme)('colorBrandPrimaryLight'), (0, _styledTools.theme)('colorBackgroundNeutral20'))};
  background-color: ${(0, _styledTools.ifProp)('isSelected', (0, _styledTools.theme)('colorBrandPrimaryLight'), 'transparent')};

  @media (hover: hover) {
    &:hover {
      background-color: ${(0, _styledTools.theme)('colorBrandPrimaryLight')};
    }
  }
`;
exports.InstallmentsQuantityButton = InstallmentsQuantityButton;
const InstallmentsLabel = (0, _stylitas.styled)(_typography.Typography)`
  margin-bottom: 24px;
  line-height: 16px;
  letter-spacing: 1.5px;

  ${_styleUtilities.media.md`
    margin-bottom: 16px;
    line-height: 20px;
    letter-spacing: 1.5px;
  `}
`;
exports.InstallmentsLabel = InstallmentsLabel;
const InstallmentInfo = (0, _stylitas.styled)(_typography.Typography)`
  line-height: 36px;
  margin-bottom: 4px;
  text-align: center;

  ${_styleUtilities.media.md`
    font-weight: 400;
  `}
`;
exports.InstallmentInfo = InstallmentInfo;
const MonthlyFeeObservations = (0, _stylitas.styled)(_typography.Typography)`
  letter-spacing: 0.3px;

  ${_styleUtilities.media.md`
    letter-spacing: 0.3px;
  `}
`;
exports.MonthlyFeeObservations = MonthlyFeeObservations;